/**
 * Shared UI constants used throughout the application
 */

export const HEADER_HEIGHT_PX = 64
